import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth, esGestorPersonal } from './stores/auth';
import Login from './pages/Login';
import Home from './pages/Home';
import MiPersonal from './pages/MiPersonal';
import Guardia from './pages/Guardia';
import Turnos from './pages/Turnos';
import Auditoria from './pages/Auditoria';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = useAuth((s) => s.accessToken);
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

/** Solo gestores (jefe/admin/superadmin) acceden a Mi Personal. */
function GestorRoute({ children }: { children: React.ReactNode }) {
  const token = useAuth((s) => s.accessToken);
  const rol = useAuth((s) => s.user?.rol);
  if (!token) return <Navigate to="/login" replace />;
  if (!esGestorPersonal(rol)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
      <Route path="/personal" element={<GestorRoute><MiPersonal /></GestorRoute>} />
      <Route path="/guardia" element={<GestorRoute><Guardia /></GestorRoute>} />
      <Route path="/turnos" element={<GestorRoute><Turnos /></GestorRoute>} />
      <Route path="/auditoria" element={<GestorRoute><Auditoria /></GestorRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
